module.exports = __webpack_public_path__ + "ga.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ga.svg
// module id = 554
// module chunks = 0